import React, { useState } from "react";
import styled from "styled-components";
import { useAuth } from "@/lib/Authentication/hooks/useAuth";
import {
  filterMePageItems,
  mePageItemsEnum,
} from "../../elements/CustomerProfile/consts";
import { useStore } from "@/lib/storeData/StoreContext";
import Flex from "@/shared/globals/UiElements/Flex";
import tailwindConfig from "@/../tailwind.config";
import { Link } from "@/i18n/i18n-navigation";
import CentralizedModal from "@/components/Centralizedlogin/CentralizedModal";
import { AuthMode } from "@/generated/graphql";
import { FormattedMessage } from "@/i18n/i18n-client";
import { CustomerIcon } from "@/assets/Icons/CustomerIcon";

const AccountButton = () => {
  const { isLoggedIn, logout } = useAuth();
  const { areReviewsActivated, authMode } = useStore();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLoginClick = () => {
    if (authMode === AuthMode.Modern) {
      setIsModalOpen(true);
    }
  };

  return (
    <>
      {isLoggedIn ? (
        <StyledContainer className="text-gray-700">
          {filterMePageItems(areReviewsActivated).map((item) =>
            item.id !== mePageItemsEnum.LogOut ? (
              <Link key={item.id} href={`/me/${item.slug}/`}>
                <StyledButton>
                  {item.icon}
                  {item.title}
                </StyledButton>
              </Link>
            ) : (
              <div className="border-t border-gray-200" key={item.id}>
                <StyledButton onClick={logout}>
                  <Flex
                    className="rounded-full shadow-xs border border-gray-300 py-xs px-md"
                    justifyContent="center"
                    alignItems="center "
                    fullWidth
                  >
                    {item.icon}
                    {item.title}
                  </Flex>
                </StyledButton>
              </div>
            )
          )}
        </StyledContainer>
      ) : authMode === AuthMode.Modern ? (
        <>
          <StyledContainer className="text-gray-700">
            <StyledButton onClick={handleLoginClick}>
              <CustomerIcon
                color={tailwindConfig.theme.extend.colors.gray[700]}
                width="20px"
                height="20px"
              />
              <FormattedMessage defaultMessage="Login" id="AyGauy" />
            </StyledButton>
          </StyledContainer>
          <CentralizedModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        </>
      ) : (
        <StyledContainer className="text-gray-700">
          <Link href={"/login"}>
            <StyledButton>
              <CustomerIcon
                color={tailwindConfig.theme.extend.colors.gray[700]}
                width="20px"
                height="20px"
              />
              <FormattedMessage defaultMessage="Login" id="AyGauy" />
            </StyledButton>
          </Link>
        </StyledContainer>
      )}
    </>
  );
};

export default AccountButton;

const StyledContainer = styled.div`
  width: 100%;
`;

const StyledButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  font-weight: 500;
  font-size: 16px;
  color: ${tailwindConfig.theme.extend.colors.gray[700]};
  svg {
    margin-inline-end: 5px;
  }
`;
